/*
 * @Author: zhangyuan zhangyuan@cheyipai.com
 * @Date: 2022-06-27 15:32:55
 * @LastEditors: zhangyuan your_email
 * @LastEditTime: 2024-10-14 15:13:41
 * @FilePath: /report-template/src/main.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { store, key } from './store'
import '@/util/flexible'
import '@/style/index.less'
// import Vconsole from 'vconsole'
import directives from '@/directives/index';
import '@/assets/fonts/iconfont.css';

Object.keys(directives).forEach(k => createApp(App).use(directives[k]));
const env = process.env.VUE_APP_ENV === 'production' ? 'production' : 'development';
console.log('processenv:', process.env.VUE_APP_ENV, 'env:', env);
// if (env !== 'production') {
//     let vConsole: any = new Vconsole()
//     createApp(App).use(vConsole)
// }


//路由跳转后，页面回到顶部
router.afterEach((to, from) => {
    if(to.path === "/explain" || 
        to.path === "/ecu" || 
        to.path === "/idlefishExplain" || 
        to.path === "/idlefishIntroduction" || 
        to.path === "/idlefishPhotoList" ||
        to.path === "/explainFreeCheck" ||
        to.path === "/ecuToC" ||
        to.path === "/explainFreeAuth" ||
        to.path === "/checkStandard"
        ) {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
    // window.scrollTo(0, 0)
})
createApp(App).use(store, key).use(router).mount('#app')

